import { Linear, gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class MovingText {
    constructor(el) {
        this.DOM = { el: el };
        this.initEvents();
    }

    initEvents() {
        this.render();
        this.addEventListeners();
        this.createTimeline();
        
        this.reversed = this.DOM.el.className.includes('is-reversed');

        gsap.to(this.DOM.el.querySelectorAll('.moving-text__inner'), {
            scrollTrigger: {
                trigger: this.DOM.el,
                start: () => {
                    return `-=${window.innerHeight} top`;
                },
                end: () => {
                    return `100%+=${window.innerHeight} bottom`;
                },
                scrub: 0.6,
            },
            x: this.reversed ? '10%' : '-10%',
            ease: Linear.easeNone,
        });
    }

    render() {
        const movingTextHTML = this.DOM.el.querySelector('.moving-text__inner').innerHTML;
        this.DOM.el.querySelector(
            '.moving-text__inner'
        ).innerHTML = `${movingTextHTML}${movingTextHTML}${movingTextHTML}${movingTextHTML}${movingTextHTML}${movingTextHTML}`;
    }

    addEventListeners() {
        this.prevScroll = window.scrollY;
        window.addEventListener('scroll', () => {
            const direction = this.prevScroll > window.scrollY ? -1 : 1;
            this.prevScroll = window.scrollY;
            this.setDirection(direction);
        });
    }

    setDirection(direction) {
        if (this.direction === direction) {
            return;
        }

        if (this.reversed) {
            if (direction === 1) {
                this.tl.reverse();
                this.tlLine.reverse();
            } else {
                this.tl.play();
                this.tlLine.play();
            }
        } else {
            if (direction === 1) {
                this.tl.play();
                this.tlLine.play();
            } else {
                this.tl.reverse();
                this.tlLine.reverse();
            }
        }

        this.direction = direction;
    }

    get timeScale() {
        const el = this.DOM.el.querySelector('p');
        const bounding = el.getBoundingClientRect();

        return window.innerWidth / bounding.width / 60;
    }

    createTimeline() {
        gsap.config({
            force3D: false,
        });

        this.tl = gsap.timeline({
            repeat: -1,
        });

        this.tl.timeScale(this.timeScale);
        this.tl.seek(10000000);

        this.tl.to(
            this.DOM.el.querySelectorAll('p'),
            {
                duration: 1,
                x: '-100%',
                ease: Linear.easeNone,
            },
            0
        );

        this.tlLine = gsap.timeline({
            repeat: -1,
        });

        this.tlLine.seek(10000000);
    }
}

const movingTextNodes = Array.from(document.querySelectorAll('[data-moving-text]'));
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (movingTextNodes !== null && !prefersReducedMotion) {
    movingTextNodes.forEach((el) => { new MovingText(el); })
}
